import _ from 'underscore';
import Abstract from '../../framework/Abstract';

import './D4.1-shipping-info.scss';

class D41ShippingInfo extends Abstract {
	init = () => {
		const radioBtns = this.root.getElementsByClassName('form__item__checkbox-and-radio-label');

		_.each(radioBtns, (radioBtn) => {
			radioBtn.addEventListener('click', this.onRadioChange, false);
		});
	}

	onRadioChange = () => {
		const carrierInfo = this.root.getElementsByClassName('D4-1-shipping-info__options__carrier-info')[0];
		const carrierInfoRadioBtn = document.getElementById('D4-1-shipping-info__options__carrier-info_expedited');

		if (carrierInfoRadioBtn.checked) {
			carrierInfo.classList.add('is-visible');
		} else {
			carrierInfo.classList.remove('is-visible');
		}
	}
}

export default D41ShippingInfo;
